import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../Context/AuthProvider/AuthProvider';
import useSeller from '../Hooks/useSeller';
import Loading from '../Pages/Shared/Loading/Loading';

const SellerRoute = ({children}) => {
    const {user, loading} = useContext(AuthContext)
    const location = useLocation();
    const [isSeller, isSellerLoading] = useSeller(user?.email)
    
    if(loading || isSellerLoading){
        return <Loading></Loading>
    }

    if(user && isSeller){
        return children
    }

    return <Navigate to="/signin" state={{ from: location }} replace></Navigate>

};

export default SellerRoute;